import { LinearProgress, styled } from '@mui/material'

import { customCommonColors } from '@front/theme/constants/palette'

export const StyledLinearProgress = styled(LinearProgress)`
  &.MuiLinearProgress-root {
    height: 8px;
    border-radius: 8px;
  }

  &.MuiLinearProgress-colorPrimary {
    background-color: ${customCommonColors.grey0};
  }

  .MuiLinearProgress-barColorPrimary {
    background-color: ${customCommonColors.blue15};
    border-radius: 8px;
  }
`
